export const GET_CHAPTERS_BY_MODULE_ID_REQUEST =
  "GET_CHAPTERS_BY_MODULE_ID_REQUEST";
export const GET_CHAPTERS_BY_MODULE_ID_SUCCESS =
  "GET_CHAPTERS_BY_MODULE_ID_SUCCESS";
export const GET_CHAPTERS_BY_MODULE_ID_FAILURE =
  "GET_CHAPTERS_BY_MODULE_ID_FAILURE";

export const GET_CHAPTER_BY_ID_REQUEST = "GET_CHAPTER_BY_ID_REQUEST";
export const GET_CHAPTER_BY_ID_SUCCESS = "GET_CHAPTER_BY_ID_SUCCESS";
export const GET_CHAPTER_BY_ID_FAILURE = "GET_CHAPTER_BY_ID_FAILURE";

export const ADD_CHAPTER_REQUEST = "ADD_CHAPTER_REQUEST";
export const ADD_CHAPTER_SUCCESS = "ADD_CHAPTER_SUCCESS";
export const ADD_CHAPTER_FAILURE = "ADD_CHAPTER_FAILURE";

export const DELETE_CHAPTER_REQUEST = "DELETE_CHAPTER_REQUEST";
export const DELETE_CHAPTER_SUCCESS = "DELETE_CHAPTER_SUCCESS";
export const DELETE_CHAPTER_FAILURE = "DELETE_CHAPTER_FAILURE";

export const UPDATE_CHAPTER_ORDER_REQUEST = "UPDATE_CHAPTER_ORDER_REQUEST";
export const UPDATE_CHAPTER_ORDER_SUCCESS = "UPDATE_CHAPTER_ORDER_SUCCESS";
export const UPDATE_CHAPTER_ORDER_FAILURE = "UPDATE_CHAPTER_ORDER_FAILURE";

export const UPDATE_CHAPTER_REQUEST = "UPDATE_CHAPTER_REQUEST";
export const UPDATE_CHAPTER_SUCCESS = "UPDATE_CHAPTER_SUCCESS";
export const UPDATE_CHAPTER_FAILURE = "UPDATE_CHAPTER_FAILURE";

export const REUPLOAD_VIDEO_INIT_REQUEST = "REUPLOAD_VIDEO_INIT_REQUEST";
export const REUPLOAD_VIDEO_INIT_SUCCESS = "REUPLOAD_VIDEO_INIT_SUCCESS";
export const REUPLOAD_VIDEO_INIT_FAILURE = "REUPLOAD_VIDEO_INIT_FAILURE";

export const UPDATE_ARTICLE_REQUEST = "UPDATE_ARTICLE_REQUEST";
export const UPDATE_ARTICLE_SUCCESS = "UPDATE_ARTICLE_SUCCESS";
export const UPDATE_ARTICLE_FAILURE = "UPDATE_ARTICLE_FAILURE";

export const GET_ARTICLE_BY_CHAPTER_ID_REQUEST = "GET_ARTICLE_BY_CHAPTER_ID_REQUEST";
export const GET_ARTICLE_BY_CHAPTER_ID_SUCCESS = "GET_ARTICLE_BY_CHAPTER_ID_SUCCESS";
export const GET_ARTICLE_BY_CHAPTER_ID_FAILURE = "GET_ARTICLE_BY_CHAPTER_ID_FAILURE";

export const CLEAR_ARTICLE_CONTENT = "CLEAR_ARTICLE_CONTENT";

export const DELETE_ARTICLE_REQUEST = "DELETE_ARTICLE_REQUEST";
export const DELETE_ARTICLE_SUCCESS = "DELETE_ARTICLE_SUCCESS";
export const DELETE_ARTICLE_FAILURE = "DELETE_ARTICLE_FAILURE";

export const RESET_ADD_CHAPTER = "RESET_ADD_CHAPTER";
